module.exports = __webpack_public_path__ + "img/26.9702bc06.jpeg";